export const notificationKeys = {
  root: ['notifications'] as const,
  mine: () => ['notifications', 'mine'] as const,
  unreadCount: () => ['notifications', 'unread-count'] as const,
}
